<template>
  <div style="margin-bottom: 15px">
    <div class="ui top attached menu" v-bind:class="{ container: !wide }">
      <div class="ui dropdown icon item" ref="module_dropdown">
        <i :class="this.$props.icon + ' icon'"></i>
        <div class="menu" v-if="this.$props.configurable">
          <div class="ui dropdown icon item" v-on:click="configure">
            <i class="sliders horizontal icon"></i>
            {{ $t("configure") }}
          </div>
        </div>
      </div>
      <div class="ui dropdown icon item" v-on:click="title_clicked">
        {{ this.$props.title }}
      </div>
      <div class="right menu">
        <div
          class="ui dropdown icon item"
          ref="menu_dropdown"
          v-for="(menu, index) in header_menus"
          v-bind:key="'X' + index"
        >
          <i :class="menu.icon + ' icon'"></i>
          <div class="menu">
            <div
              class="ui dropdown icon item"
              v-on:click="btn.click"
              v-for="(btn, idx) in menu.buttons"
              v-bind:key="'X' + idx"
            >
              <i :class="btn.icon + ' icon'"></i>
              {{ btn.text }}
            </div>
          </div>
        </div>
        <div
          class="ui dropdown icon item"
          style="padding: 0px 11px"
          v-on:click="handle_header_button_click(button)"
          v-for="(button, index) in header_buttons_"
          v-bind:key="index"
        >
          <div class="button" :data-tooltip="button.tooltip">
            <i
              :class="button.icon + ' icon ' + button.color"
              style="margin: 0"
            ></i>
          </div>
        </div>
        <div
          class="ui dropdown icon item"
          v-on:click="toggle"
          v-if="this.$props.show_toggle"
        >
          <i
            class
            v-bind:class="{
              'expand icon': this.compressed,
              'compress icon': !this.compressed,
            }"
          ></i>
        </div>
        <div
          class="ui dropdown icon item"
          v-if="this.$props.show_back"
          v-on:click="back"
        >
          <i class="left arrow icon"></i>
        </div>
        <div
          class="ui dropdown icon item"
          v-if="this.$props.show_plus"
          v-on:click="add"
        >
          <i class="plus green icon"></i>
        </div>
        <div
          class="ui right aligned category search item"
          v-if="this.$props.searchable"
          ref="search"
        >
          <div class="ui transparent icon input">
            <input
              class="prompt"
              type="text"
              v-bind:placeholder="$t('search')"
              v-model="filter"
            />
            <i class="search link icon"></i>
          </div>
        </div>
      </div>
    </div>
    <div
      class="ui bottom attached segment"
      ref="main_segment"
      v-bind:class="{ loading: processing, container: !wide }"
    >
      <div class="ui placeholder" v-if="processing">
        <div class="image header">
          <div class="line"></div>
          <div class="line"></div>
        </div>
      </div>
      <slot v-bind:class="{ hidden: processing }"></slot>
    </div>

    <template v-for="(mdl, index) in configure_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:succedded="succedded"
        v-on:destroy="destroy"
      ></component>
    </template>
  </div>
</template>

<script>
import { init_search } from "../utils";

export default {
  props: {
    icon: String,
    configurable: Boolean,
    title: String,
    searchable: Boolean,
    show_plus: Boolean,
    show_back: Boolean,
    show_toggle: { type: Boolean, default: true },
    configure_modal: Object,
    header_buttons: Array,
    header_menus: Array,
    object: Object,
    wide: Boolean,
    show_refresh: Boolean,
  },
  components: {},
  data() {
    return {
      processing: false,
      configure_modals: [],
      filter: "",
      compressed: false,
      header_buttons_: [],
    };
  },
  methods: {
    configure() {
      // console.log("configuring modal");
      let vm = this;
      if (vm.$props.configure_modal)
        vm.configure_modals.push(vm.$props.configure_modal);
      else vm.$emit("configure");
    },
    succedded() {
      console.log("succedded");
    },
    add() {
      this.$emit("add");
    },
    back() {
      this.$router.go(-1);
    },
    title_clicked() {
      this.$emit("title_click");
    },
    handle_header_button_click(button) {
      button.click(this.$props.object);
    },
    destroy() {
      this.configure_modals = [];
    },
    toggle() {
      this.compressed = !this.compressed;
      window.jQuery(this.$refs.main_segment).slideToggle("fast");
    },
    set_loading(value) {
      this.processing = value;
    },
    init_search_control(opts = {}) {
      let vm = this;
      // console.log("initing with opts", opts);

      init_search(
        vm,
        this.$refs.search,
        opts.action,
        opts.onSearchResponse,
        opts.onSearchSelect,
        opts,
      );
    },
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.module_dropdown).dropdown();
    window.jQuery(vm.$refs.menu_dropdown).dropdown();
    vm.header_buttons_ = this.$props.header_buttons || [];
    if (vm.$props.show_refresh) {
      vm.header_buttons_.push({
        icon: "green refresh",
        click: () => {
          vm.$emit("refresh");
        },
        tooltip: vm.$t("refresh"),
      });
    }
  },
  watch: {
    filter() {
      this.$emit("filter", this.filter);
    },
  },
};
</script>

<style>
.view {
  margin-bottom: 15px;
}
</style>
